export default function mobileValidation(value) {
  const firstDigit = value.charAt(0)
  const secondDigit = value.charAt(1)
  if (!value.length) {
    return true
  } else {
    if (firstDigit !== "0" || secondDigit !== "9") {
      return "شماره موبایل نادرست است"
    } else {
      return true
    }
  }
}
